import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import styled from 'styled-components';
import themebutton from '../res/styles/theme_button.module.scss';
import Button from './Button';
import { CONFIRM, CANCEL } from '../res/Constants';

export default class ConfirmDialog extends PureComponent {
    static propTypes = {
        isOpen: PropTypes.bool,
        text: PropTypes.string,
        elementId: PropTypes.any.isRequired,
        onConfirm: PropTypes.func,
        confirmClassName: PropTypes.string,
        cancelClassName: PropTypes.string,
        confirmText: PropTypes.string
    };

    static defaultProps = {
        confirmClassName: null,
        cancelClassName: null,
        confirmText: null
    };

    onConfirm = (confirm) => {
        this.props.onConfirm && this.props.onConfirm(this.props.elementId, confirm);
    };

    render() {
        const cancelClass = this.props.cancelClassName ?? themebutton.red;
        const confirmClass = this.props.confirmClassName ?? themebutton.green;
        const confirmText = this.props.confirmText ?? CONFIRM.toUpperCase();

        return (
            <Modal isOpen={this.props.isOpen} centered={true}>
                <ModalBody>
                    <p style={{ minHeight: '70px', textAlign: 'center', whiteSpace: 'pre-line' }}>{this.props.text}</p>
                    <StyledButtonsFooter>
                        <Button
                            className={[cancelClass, 'w-40', 'mx-auto'].join(' ')}
                            onClick={() => this.onConfirm(false)}
                            text={CANCEL.toUpperCase()}
                        />
                        <Button
                            className={[confirmClass, 'w-40', 'mx-auto'].join(' ')}
                            onClick={() => this.onConfirm(true)}
                            text={confirmText}
                        />
                    </StyledButtonsFooter>
                </ModalBody>
            </Modal>
        );
    }
}

const StyledButtonsFooter = styled.div`
    display: flex;
    justify-content: space-evenly;

    .btn {
        border-radius: 24px;
    }
`;
